// "Bekijk als": een beheerder neemt tijdelijk de rechten van een andere gebruiker over, maar blijft zelf ingelogd
// (en ziet dus zijn eigen gegevens). De keuze geldt enkel voor dit browsertabblad en verdwijnt bij sluiten of uitloggen.
const KEY = "bonamuze-view-as";
const EVENT = "bonamuze:view-as";

export function getViewAs() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

function notify() {
  window.dispatchEvent(new Event(EVENT));
}

/** @param {{user_id: string, permissions: string[]}} target - antwoord van GET /users/{id}/view-as */
export function startViewAs(target) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(target));
  } catch (e) {
    return;
  }
  notify();
}

export function stopViewAs() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {
    // niets te doen
  }
  notify();
}

export function onViewAsChange(listener) {
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}

export const VIEW_AS_HEADER = "X-View-As";
